import { Base } from "../core/base.model";


export class SegmentoCliente extends Base {

    public id: number;
	public segmento:string;
	public descripcion:string;
	public estatus:string;

}

